import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { SlideToConfirm } from "@/components/ui/slide-to-confirm"
import type { KnowledgeDocument } from "../../domain/entities/document"

type Props = {
  target: KnowledgeDocument | null
  onClose: () => void
  onConfirm: (id: string) => void
  isPending: boolean
}

export const DeleteDocumentDialog = ({ target, onClose, onConfirm, isPending }: Props) => (
  <Dialog open={!!target} onOpenChange={(open) => { if (!open) onClose() }}>
    <DialogContent className="sm:max-w-md">
      <DialogHeader>
        <DialogTitle>Delete document</DialogTitle>
      </DialogHeader>

      <p className="text-sm text-muted-foreground">
        Are you sure to delete{" "}
        <span className="font-medium text-foreground">{target?.name}</span>?
      </p>

      <SlideToConfirm
        label={isPending ? "Deleting…" : "Slide to confirm"}
        onConfirm={() => target && onConfirm(target.id)}
        className="mt-2"
        isDanger={true}
      />
    </DialogContent>
  </Dialog>
)
